import axios from "axios";
import { jwtDecode } from "jwt-decode";

const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem("qmsToken", token);
    const decoded =
      localStorage.qmsToken && jwtDecode(localStorage.qmsToken);

    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.common["user_id"] = parseInt(decoded.uid);
  } else {
    delete axios.defaults.headers.common["Authorization"];
    delete axios.defaults.headers.common["user_id"];
    localStorage.removeItem("qmsToken");
  }
};

export default setAuthToken;
